import React from "react";
import { merge, defaultTo } from "lodash";
import { Theme } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { FormLabel, FormHelperText } from "@material-ui/core";
import BaseSelect from "react-select";

const useStyles = makeStyles((theme) => ({
  label: {
    display: "block",
    marginBottom: theme.spacing(1),
  },
  helperText: {
    margin: "8px 14px 0px",
  },
}));

interface Props extends React.ComponentProps<typeof BaseSelect> {
  error?: boolean;
  helperText?: React.ReactNode;
}

export default ({ label, error, helperText, ...props }: Props) => {
  const styles = useStyles();
  const theme = useTheme<Theme>();
  return (
    <>
      {label && (
        <FormLabel className={styles.label} error={error}>
          {label}
        </FormLabel>
      )}
      <BaseSelect
        placeholder="選択してください"
        noOptionsMessage={({ inputValue }) =>
          `「${inputValue}」に一致する項目はありません`
        }
        theme={(t) =>
          merge(
            {
              colors: {
                primary: theme.palette.primary.main,
                primary25: theme.palette.primary.light,
                neutral20: defaultTo(error, false)
                  ? theme.palette.error.main
                  : "#ccc",
              },
            },
            t
          )
        }
        {...props}
      />
      {helperText && (
        <FormHelperText className={styles.helperText} error={error}>
          {helperText}
        </FormHelperText>
      )}
    </>
  );
};
